import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryButton } from 'common/components';
import { ReactComponent as CloseIcon } from 'applicaiton/assets/close.svg';
import { ReactComponent as SuccesslIcon } from 'applicaiton/assets/success-icon.svg';
import { StyledModal } from './styles';
import { Modal } from '@mui/material';

interface SuccessModalProps {
  topicName: string;
  onClose: () => void;
}

const SuccessModal: FC<SuccessModalProps> = ({ topicName, onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal open={true}>
      <StyledModal>
        <CloseIcon onClick={onClose} />
        <div>
          <SuccesslIcon />
          <p>
            {t('topics_of_chats.success_delete_topic.title1')}{' '}
            <span>{topicName}</span>{' '}
            {t('topics_of_chats.success_delete_topic.title2')}
          </p>
          <SecondaryButton onClick={onClose}>{t('ok')}</SecondaryButton>
        </div>
      </StyledModal>
    </Modal>
  );
};

export default SuccessModal;
